<template>
  <v-container fluid class="wdg_view_Check_box">
    <v-row justify="center" >
      <v-card
        tile
        height="100%"
        style="border-radius: 25px 25px 0 0;"
        width="95%"
        :style="bdyColor"
      >
        <v-container
          class="fluid"
          :style="bcgColor"
          style=" width:100%;height: 120px"
        >
          <v-row style="width:100%; height:30%" justify="end" align="center" @click="toggleDialog()">
            <v-icon color="#0247a7">
              mdi-close
            </v-icon>
          </v-row>
        </v-container>
        <v-overlay
          absolute
          :value="dialog"
          style="border-radius: 25px 25px 0 0;"
          class="pa-10"
          z-index="1"
        >
          <v-card color="white" tile class="pb-4  ovr_pd">
            <v-row justify="end" class="pr-5 pt-2">
              <v-btn x-small icon @click="ovrlyClose()">
                <v-icon color="#323F4F"  >
                  mdi-window-close
                </v-icon>
              </v-btn>
            </v-row>
            <v-card-text
              style="color:#323F4F ;text-align: center; font-size:14px ; padding-left: 15px ; padding-right: 15px"
            >
              {{ $t("widgets.modalText1") }}
            </v-card-text>
            <v-card-text
              style="color:#323F4F ; text-align: center; font-size:14px; padding-left: 15px ; padding-right: 15px"
            >
              {{ $t("widgets.modalText2") }}
            </v-card-text>
          </v-card>
        </v-overlay>
        <v-container
          class="fluid pr-2 pl-6 py-0"
          :style="bdyColor"
          style=" width:100%;"
          id="modalContainer"
        >
          <v-row
            style="height:100%;width:102.5%"
            class=" title_offer"
            align="center"
            justify="center"
            @click="toggleDialog()"
          >
            <span :style="titleProps">{{ titleText }}</span>
          </v-row>

          <v-row
            style="width:102.5%"
            class="text_offer"
            justify="center"
            align="center"
            v-if="wdgtTabcheck"
            @click="toggleDialog()"
          >
            <v-col class="py-0">
              <p :style="msgProps" class="mb-0">{{ msgText }}</p>
            </v-col>
          </v-row>

          <v-row
            style="width:102.5%"
            class="text_offer"
            align="center"
            justify="center"
            v-if="!wdgtTabcheck"
            @click="toggleDialog()"
          >
            <v-col>
              <p :style="msgProps">{{ msgText }}</p>
            </v-col>
          </v-row>

          <v-row
            style="width:102.5%"
            align="center"
            justify="center"
            v-show="wdgtTabHaveTwo"
            :style="bdyColor"
          >
            <!--            && !detectEuRegion-->
            <!--            v-if="getTwoRight"-->
            <v-tabs v-model="tab" light centered color="transparent" :style="bdyColor" :background-color="getBgWidgCheckBody">
              <v-tab light :style="bdyColor" @click="activeIcon(getTabHeader1)" v-if="getTabHeader1 !== undefined">
                <!--                v-if="getWidgetsState.enabled_widgets.keTabHeader1.enabled"-->
                <component v-bind:is="getTabHeader1" :class="opacity != getTabHeader1 ? 'opacPresent' : ''" ></component>
              </v-tab>
              <v-tab light :style="bdyColor" @click="activeIcon(getTabHeader2)" v-if="getTabHeader2 !== undefined">
                <!--                v-if="getWidgetsState.enabled_widgets.keTabHeader2.enabled"-->
                <component v-bind:is="getTabHeader2" :class="opacity != getTabHeader2 ? 'opacPresent' : ''" ></component>
              </v-tab>
              <v-tab light :style="bdyColor"  @click="activeIcon(getTabHeader3)" v-if="getTabHeader3 !== undefined">
                <!--                v-if="getWidgetsState.enabled_widgets.keTabHeader3.enabled"-->
                <component v-bind:is="getTabHeader3" :class="opacity != getTabHeader3 ? 'opacPresent' : ''" ></component>
              </v-tab>
              <!--              <v-divider vertical></v-divider>-->
            </v-tabs>
          </v-row>

          <!--          /* SMS with Discount */-->
          <v-col cols="11" v-if="!wdgtTabWhatsappOnly && wdgtSMScheck && wdgtIsDsc" @click="toggleDialog">
            <v-row
              style="width:100%; border: 1px solid #c9cacb; margin-left:1%"
              align="center"
              justify="center"
              class="pa-0 my-0"

            >
              <v-col cols="3" class="img_vh ma-0 pa-0" style="height:100%;width:100%">
                <v-img
                  src="https://storage.googleapis.com/dev-facebook-cart-recovery.appspot.com/widget/img/discount-icon.png"
                  class="ma-0 pa-0"
                  width="100%"
                  style="background:#4E5D6B"
                  height="34vh"
                >
                </v-img>
              </v-col>
              <v-col cols="9"  style="height:34vh" class="d-flex align-content-space-around  flex-wrap py-0 pl-12" v-if="checkOptin">
                <v-col style="width:100%" class="py-0" v-if="dscntCd">
                  <span style="font-weight:bold;font-size:120%; color:#5686F6;width: 100%" :style="msgProps">
                    {{ dscntCd }}
                  </span>
                </v-col>
                <v-row style="width:100%" class="py-0" >
                  <span style="width: 100%">
                    {{ dscntInstr }}
                  </span>
                </v-row>
                <v-row style="width:100%" class="py-0" >
                  <v-btn :style="buttonProps" outlined @click="resetOptin">
                  <span :style="btnTextProps">
                    {{ $t("widgets.cpDiscCode") }}
                  </span>
                  </v-btn>
                </v-row>
              </v-col>
              <v-col cols="9" class="py-0 d-flex align-content-space-around  flex-wrap py-0 pl-12" style="height: 34vh" v-if="!checkOptin">
                <v-row style="width:100%;" class="py-0 pr-2">
                  <span style="font-weight:bold; font-size:90%" :style="msgProps">
                    {{ dscntStmt }}
                  </span>
                </v-row>
                <v-row style="width:100%;" class=" py-0 mt-2">

                  <v-col cols="12"  class="pl-0">
                    <vue-tel-input
                      v-model="optinNum"
                      dark
                      style="width:100%;"
                      placeholder=""
                      :showDialCode="true"
                      mode="international"
                      disabled
                    >
                    </vue-tel-input>
                  </v-col>

                </v-row>
                <v-row style="width:100%" class="" align="start">
                  <v-btn
                    :style="buttonProps"
                    style="width: 97.5%"
                    outlined
                    :key="widgetKey"
                    @click="submitClickDisc"
                    disabled
                  >
                  <span :style="btnTextProps">
                    {{ buttonText }}
                  </span>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <!--          /* SMS with Whatsapp Discount */-->
          <v-col cols="11" class="ml-3 no_pad_min_width"   v-if="wdgtTabWhatsappOnly &&wdgtSMScheck && wdgtIsDsc" @click="toggleDialog()">
              <v-row
                style="border:1px solid #C9CACB;"
                align="center"
                justify="center"
                :key="'key2' + wdgtTabKey"
                class="mt-4"
              >
                <v-col cols="3" class="img_vh ma-0 pa-0" style="height:100%;width:100%">
                  <v-img
                    src="https://storage.googleapis.com/dev-facebook-cart-recovery.appspot.com/widget/img/discount-icon.png"
                    class="ma-0 pa-0"
                    width="100%"
                    height="35vh"
                    style="background:#4E5D6B"
                  >
                  </v-img>
                </v-col>
                <v-col cols="9" class="d-flex align-content-space-around  flex-wrap py-0 pl-12" style="height: 35vh !important;" v-if="checkOptin">
                  <v-col style="width:100%" class="py-0 pr-2" v-if="dscntCd">
                    <span style="font-weight:bold;font-size:120%; color:#5686F6;width: 100%" :style="msgProps">
                      {{ dscntCd }}
                    </span>
                  </v-col>
                  <v-row style="width:100%" class="py-0 pr-2" >
                    <span style="width: 100%">
                      {{ dscntInstr }}
                    </span>
                  </v-row>

                  <v-row style="width:100%" class=" pr-2" >
                    <v-btn :style="buttonProps" outlined @click="resetOptin">
                    <span :style="btnTextProps" style="width: 100%">
                      {{cpDiscCode}}
                    </span>
                    </v-btn>
                  </v-row>
                </v-col>

                <v-col cols="9" class="d-flex align-content-space-around  flex-wrap" v-if="!checkOptin" style="height: 35vh !important;">
                  <v-col style="width:100%" class="py-0 pr-2">
                      <span style="font-weight:bold; font-size:90%" :style="msgProps">
                        {{ dscntStmt }}
                      </span>
                    <v-col style="width:100%" class="py-0 pl-0 pt-8" disabled>
                      <v-col style="width:100%; " align="center" class="px-0 py-0" :style="bdyColor">
                        <v-col cols="12" class="px-0 py-0" :style="bdyColor">
                          <v-tabs-items v-model="tab" style="width:100%">
                            <v-tab-item :value="getTabKeySMS" style="width:100%" class="pl-0 py-5" :style="bdyColor" disabled>

                              <vue-tel-input
                                v-model="optinNum"
                                dark
                                style="width:103.5%;"
                                placeholder=""
                                :showDialCode="true"
                                mode="international"
                                disabled
                              >
                              </vue-tel-input>
                            </v-tab-item>
                            <v-tab-item :value="getTabKeyWa">
                              <vue-tel-input
                                v-model="optinNum"
                                dark
                                style="width:103.5%;"
                                placeholder=""
                                :showDialCode="true"
                                mode="international"
                                disabled
                              >
                              </vue-tel-input>
                            </v-tab-item>
                          </v-tabs-items>
                        </v-col>
                      </v-col>
                    </v-col>
                  </v-col>
                  <v-row style="width:100%" class="pl-6  " align="start" disabled>
                    <v-btn
                      :style="buttonProps"
                      outlined
                      :key="widgetKey"
                      @click="submitClickDisc"
                      style="width: 96%"
                      disabled
                    >
                      <span :style="btnTextProps">
                        {{ buttonText }}
                      </span>
                    </v-btn>
                  </v-row>
                </v-col>

              </v-row>
            </v-col>
<!--          /* Whatsapp with Discount*/-->
          <v-col cols="11" v-if="wdgtTabWhatsapp && wdgtIsDsc" @click="toggleDialog">
            <v-row
              style="width:100%; border: 1px solid #c9cacb; margin-left:1%"
              align="center"
              justify="center"
              class="pa-0 my-0"

            >
              <v-col cols="3" class="img_vh ma-0 pa-0" style="height:100%;width:100%">
                <v-img
                  src="https://storage.googleapis.com/dev-facebook-cart-recovery.appspot.com/widget/img/discount-icon.png"
                  class="ma-0 pa-0"
                  width="100%"
                  style="background:#4E5D6B"
                  height="34vh"
                >
                </v-img>
              </v-col>
              <v-col cols="9"  style="height:34vh" class="d-flex align-content-space-around  flex-wrap py-0 pl-12" v-if="checkOptin">
                <v-col style="width:100%" class="py-0" v-if="dscntCd">
                  <span style="font-weight:bold;font-size:120%; color:#5686F6;width: 100%" :style="msgProps">
                    {{ dscntCd }}
                  </span>
                </v-col>
                <v-row style="width:100%" class="py-0" >
                  <span style="width: 100%">
                    {{ dscntInstr }}
                  </span>
                </v-row>
                <v-row style="width:100%" class="py-0" >
                  <v-btn :style="buttonProps" outlined @click="resetOptin">
                  <span :style="btnTextProps">
                    {{ $t("widgets.cpDiscCode") }}
                  </span>
                  </v-btn>
                </v-row>
              </v-col>
              <v-col cols="9" class="py-0 d-flex align-content-space-around  flex-wrap py-0 pl-12" style="height: 34vh" v-if="!checkOptin">
                <v-row style="width:100%;" class="py-0 pr-2">
                  <span style="font-weight:bold; font-size:90%" :style="msgProps">
                    {{ dscntStmt }}
                  </span>
                </v-row>
                <v-row style="width:100%;" class=" py-0 mt-2">

                  <v-col cols="12"  class="pl-0">
                    <vue-tel-input
                      v-model="optinNum"
                      dark
                      style="width:100%;"
                      placeholder=""
                      :showDialCode="true"
                      mode="international"
                      disabled
                    >
                    </vue-tel-input>
                  </v-col>

                </v-row>
                <v-row style="width:100%" class="" align="start">
                  <v-btn
                    :style="buttonProps"
                    style="width: 97.5%"
                    outlined
                    :key="widgetKey"
                    @click="submitClickDisc"
                    disabled
                  >
                  <span :style="btnTextProps">
                    {{ buttonText }}
                  </span>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <!--          /* Whatsapp No Discount*/-->
          <v-row
            style="width:102.5%"
            align="end"
            justify="center"
            v-if="wdgtTabWhatsapp && !wdgtIsDsc"
            @click="toggleDialog()"
            :class="$vuetify.breakpoint.width > 1600 ? 'ml-0' : 'ml-2'"
          >
            <vue-tel-input
              v-model="optinNum"
              dark
              style="width:70%;"
              placeholder=""
              :showDialCode="true"
              mode="international"
              disabled
            >
            </vue-tel-input>
            <v-row
              style="width:102.5%"
              align="center"
              justify="center"
              @click="submitClickDisc()"
              class="mt-8"
            >
              <v-btn :style="buttonProps" outlined :key="widgetKey" style="width: 249px !important;height: 50px !important;">
              <span :style="btnTextProps">
                {{ buttonText }}
              </span>
              </v-btn>
            </v-row>
          </v-row>
          <!--        /* NO DISCOUNT FACEBOOK*/-->
          <v-row
            style="width:102.5%"
            align="center"
            justify="center"
            v-if="wdgtFBcheck && !wdgtIsDsc && !wdgtTabWhatsappOnly"
            @click="toggleDialog()"
            :style="bdyColor"
          >
            <v-checkbox input-value="true" disabled> </v-checkbox>
            <span class="pr-2">
              {{ $t("widgets.chckBxTxt1") }}
            </span>
            <v-icon color="#0084FF">
              mdi-facebook-messenger
            </v-icon>
            <span class="pl-2">
              {{ $t("widgets.chckBxTxt2") }}
            </span>
          </v-row>
          <!--        /* NO DISCOUNT FACEBOOK with Whatsapp*/-->
          <v-row
            style="width:102.5%"
            align="start"
            justify="center"
            v-if="wdgtFBcheck && !wdgtIsDsc && wdgtTabWhatsappOnly"
            class="pl-2"
            :key="'key1' + wdgtTabKey"
          >
            <v-tabs-items v-model="tab" style="width:90%">
              <v-tab-item :value="getTabKeyFb">
                <v-row
                  style="width:100%;height:60%"
                  align="center"
                  class="pl-1"
                  justify="center"
                  @click="toggleDialog()"
                >
                  <v-checkbox input-value="true" disabled> </v-checkbox>
                  <span class="pr-1">
                    {{ $t("widgets.chckBxTxt1") }}
                  </span>
                  <v-icon color="#0084FF">
                    mdi-facebook-messenger
                  </v-icon>
                  <span class="pl-2">
                    {{ $t("widgets.chckBxTxt2") }}
                  </span>
                </v-row>

                <v-row
                  style="width:100%;height:40%"
                  align="center"
                  justify="center"
                  @click="toggleDialog()"
                >
                  <v-container
                    style="height: 26px; width: 26px; border-radius:100%; background-color: #E6E7E8"
                    class="mx-2"
                  ></v-container>

                  <span
                    style="font-size: 14px; height:100%; color: #B3B7BA"
                    class="pt-1 mr-2"
                  >{{ $t("widgets.fbUserName") }}</span
                  >

                  <a
                    style="font-size: 13px; height:100%; color: #B3B7BA; text-decoration:underline"
                    class="pt-1"
                  >{{ $t("widgets.wrngUsrTxt") }}</a
                  >
                </v-row>
              </v-tab-item>
              <v-tab-item :value="getTabKeyWa">
                <v-row style="width:100%;height:2.5vh" :style="bdyColor">
                </v-row>
                <v-row justify="center" style="width:100%" :style="bdyColor"
                       @click="toggleDialog()" :class="$vuetify.breakpoint.width > 1600 ? 'ml-0' : 'ml-2'">
                  <vue-tel-input
                    v-model="optinNum"
                    dark
                    style="width:80%;"
                    placeholder=""
                    :showDialCode="true"
                    mode="international"
                    disabled
                  >
                  </vue-tel-input>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-row>

<!--          <v-row-->
<!--            style="width:102.5%"-->
<!--            align="start"-->
<!--            justify="center"-->
<!--            v-if="wdgtFBcheck && !wdgtIsDsc"-->
<!--            @click="toggleDialog()"-->
<!--          >-->
<!--            <v-container-->
<!--              style="height: 26px; width: 26px; border-radius:100%; background-color: #E6E7E8"-->
<!--              class="mx-2"-->
<!--            ></v-container>-->

<!--            <span-->
<!--              style="font-size: 14px; height:100%; color: #B3B7BA"-->
<!--              class="pt-1 mr-2"-->
<!--            >{{ $t("widgets.fbUserName") }}</span-->
<!--            >-->

<!--            <a-->
<!--              style="font-size: 13px; height:100%; color: #B3B7BA; text-decoration:underline"-->
<!--              class="pt-1"-->
<!--            >{{ $t("widgets.wrngUsrTxt") }}</a-->
<!--            >-->
<!--          </v-row>-->



<!--        /*  button submit (wrong way) */-->
          <v-row
            class="mt-8"
            style="width:102.5%"
            align="end"
            justify="center"
            v-if="wdgtFBcheck && !wdgtIsDsc"
            @click="toggleDialog()"
          >
            <v-btn :style="buttonProps" outlined :key="widgetKey" style="width: 249px !important;height: 50px !important;">
              <span :style="btnTextProps">
                {{ buttonText }}
              </span>
            </v-btn>
          </v-row>
          <!--        /* NO DISCOUNT SMS*/-->
          <v-row
            style="width:102.5%"
            align="end"
            justify="center"
            v-if="wdgtSMScheck && !wdgtIsDsc && !wdgtTabWhatsappOnly"
            @click="toggleDialog()"
            :class="$vuetify.breakpoint.width > 1600 ? 'ml-0' : 'ml-2'"
          >
            <vue-tel-input
              v-model="optinNum"
              dark
              style="width:70%;"
              placeholder=""
              :showDialCode="true"
              mode="international"
              disabled
            >
            </vue-tel-input>
          </v-row>
          <!--        /* NO DISCOUNT SMS with Whatsapp*/-->
          <v-row
            style="width:102.5%"
            align="end"
            justify="center"
            v-if="wdgtSMScheck && !wdgtIsDsc && wdgtTabWhatsappOnly"
            @click="toggleDialog()"
            :class="$vuetify.breakpoint.width > 1600 ? 'ml-0' : 'ml-2'"
          >
            <v-tabs-items v-model="tab" style="width:90%">
              <v-tab-item :value="getTabKeySMS">
                <v-row style="width:100%;height:2.5vh" :style="bdyColor">
                </v-row>
                <v-row justify="center" style="width:100%" :style="bdyColor"
                       @click="toggleDialog()" :class="$vuetify.breakpoint.width > 1600 ? 'ml-0' : 'ml-2'">
                  <vue-tel-input
                    v-model="optinNum"
                    dark
                    style="width:80%;"
                    placeholder=""
                    :showDialCode="true"
                    mode="international"
                    disabled
                  >
                  </vue-tel-input>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="getTabKeyWa">
                <v-row style="width:100%;height:2.5vh" :style="bdyColor">
                </v-row>
                <v-row justify="center" style="width:100%" :style="bdyColor"
                       @click="toggleDialog()" :class="$vuetify.breakpoint.width > 1600 ? 'ml-0' : 'ml-2'">
                  <vue-tel-input
                    v-model="optinNum"
                    dark
                    style="width:80%;"
                    placeholder=""
                    :showDialCode="true"
                    mode="international"
                    disabled
                  >
                  </vue-tel-input>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-row>

          <v-row
            class="mt-8"
            style="width:102.5%"
            align="center"
            justify="center"
            v-if="wdgtSMScheck && !wdgtIsDsc"
            @click="toggleDialog()"
          >
            <v-btn :style="buttonProps" outlined :key="widgetKey" style="width: 249px !important;height: 50px !important;">
              <span :style="btnTextProps">
                {{ buttonText }}
              </span>
            </v-btn>
          </v-row>


          <!--          /* Facebook with Disc. */-->
          <v-col cols="11"  v-if="!wdgtTabWhatsappOnly && wdgtFBcheck && wdgtIsDsc">
            <v-row
              style="width:100%; border: 1px solid #C9CACB; margin-left:1%"
              align="center"
              justify="center"
              class="pa-0 my-0"

            >
              <v-col cols="3" class=" ma-0 img_vh_big pa-0" style="width:100%">
                <v-img
                  src="https://storage.googleapis.com/dev-facebook-cart-recovery.appspot.com/widget/img/discount-icon.png"
                  class="ma-0 pa-0 "
                  width="100%"
                  height="35vh"
                  style="background:#4e5d6b;"
                >
                </v-img>
              </v-col>
              <v-col cols="9" class="d-flex align-content-space-around  flex-wrap" style="height:35vh" v-if="checkOptin">
                <v-row style="width:100%;" class="pl-8 pr-0" v-if="dscntCd">
                  <span style="width:100%;font-weight:bold;font-size:120%; color:#5686F6" :style="msgProps">
                    {{ dscntCd }}
                  </span>
                </v-row>
                <v-row style="width:100%" class="pl-8 pr-2" align="center">
                  <span style="width: 100%">
                    {{ dscntInstr }}
                  </span>
                </v-row>
                <v-row style="width:100%" class="pl-8 pr-2" align="start">
                  <v-btn :style="buttonProps" outlined @click="resetOptin">
                    <span :style="btnTextProps" style="width: 100%">
                      {{cpDiscCode}}
                    </span>
                  </v-btn>
                </v-row>
              </v-col>
              <v-col cols="9" class="py-0 d-flex align-content-space-around  flex-wrap" style="height:35vh" v-if="!checkOptin">
                <v-row style="width:100%;" class="py-0 pl-6 pr-2">
                    <span style="font-weight:bold; font-size:90%" :style="msgProps">
                      {{ dscntStmt }}
                    </span>
                </v-row>
                <v-row style="width:100%;" class="py-0" :style="bdyColor">

                    <v-col cols="11" class="pl-0 pt-0 ml-6" style="height:100%;" :style="bdyColor" >
                      <v-row
                        style="width:100%;height:auto"
                        align="center"
                        class="pl-2"
                        :style="bdyColor"
                      >
                        <v-checkbox
                          input-value="true"
                          disabled
                          style="transform: scale(0.8)"
                          class="pr-0 mr-0"
                        >
                        </v-checkbox>
                        <span class="pr-0" style="font-size:80%">
                           {{ $t("widgets.chckBxTxt1") }}
                        </span>
                        <v-icon color="#0084FF" style="transform: scale(0.8)">
                          mdi-facebook-messenger
                        </v-icon>
                        <span class="pl-0" style="font-size:80%">
                         {{ $t("widgets.chckBxTxt2") }}
                         </span>
                        <span> </span>
                      </v-row>

                      <v-row style="width:100%;" class="mr-5" align="start">
                        <v-container
                          style="height: 15px; width: 15px; border-radius:100%; background-color: #E6E7E8; transform: scale(0.8)"
                          class="mx-2 "
                        ></v-container>

                        <span
                          style="font-size: 70%; height:100%; color: #B3B7BA"
                          class="pt-1 mr-2"
                        >{{ $t("widgets.fbUserName") }}</span
                        >

                        <a
                          style="font-size: 70%; height:100%; color: #B3B7BA; text-decoration:underline"
                          class="pt-1"
                        >{{ $t("widgets.wrngUsrTxt") }}</a
                        >
                      </v-row>
                      <v-row style=" width:100%"> </v-row>
                    </v-col>
          
                </v-row>
                <v-row style="width:100%" class="px-6 mt-2 py-0" align="start" >
                  <v-btn
                    :style="buttonProps"
                    outlined
                    :key="widgetKey"
                    @click="submitClickDisc"
                    disabled
                    style="width: 97.5%"
                  >
                  <span :style="btnTextProps">
                    {{ buttonText }}
                  </span>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <!--          /* Facebook and Whatsapp with Disc. */-->
          <v-col cols="11" class="ml-3 no_pad_min_width"   v-if="wdgtTabWhatsappOnly && wdgtFBcheck && wdgtIsDsc" @click="toggleDialog()">
            <v-row
              style="border:1px solid #C9CACB;"
              align="center"
              justify="center"
              :key="'key2' + wdgtTabKey"
              class="mt-4"
            >
              <v-col cols="3" class="img_vh ma-0 pa-0" style="height:100%;width:100%">
                <v-img
                  src="https://storage.googleapis.com/dev-facebook-cart-recovery.appspot.com/widget/img/discount-icon.png"
                  class="ma-0 pa-0"
                  width="100%"
                  height="35vh"
                  style="background:#4E5D6B"
                >
                </v-img>
              </v-col>
              <v-col cols="9" class="d-flex align-content-space-around  flex-wrap py-0 pl-12" style="height: 35vh !important;" v-if="checkOptin">
                <v-col style="width:100%" class="py-0 pr-2" v-if="dscntCd">
                    <span style="font-weight:bold;font-size:120%; color:#5686F6;width: 100%" :style="msgProps">
                      {{ dscntCd }}
                    </span>
                </v-col>
                <v-row style="width:100%" class="py-0 pr-2" >
                    <span style="width: 100%">
                      {{ dscntInstr }}
                    </span>
                </v-row>

                <v-row style="width:100%" class=" pr-2" >
                  <v-btn :style="buttonProps" outlined @click="resetOptin">
                    <span :style="btnTextProps" style="width: 100%">
                      {{cpDiscCode}}
                    </span>
                  </v-btn>
                </v-row>
              </v-col>

              <v-col cols="9" class="d-flex align-content-space-around  flex-wrap" v-if="!checkOptin" style="height: 35vh !important;">
                <v-col style="width:100%" class="py-0 pr-2">
                      <span style="font-weight:bold; font-size:90%" :style="msgProps">
                        {{ dscntStmt }}
                      </span>
                  <v-col style="width:100%" class="py-0 pl-0 pt-8" disabled>
                    <v-col style="width:100%; " align="center" class="px-0 py-0" :style="bdyColor">
                      <v-col cols="12" class="px-0 py-0" :style="bdyColor">
                        <v-tabs-items v-model="tab" style="width:100%">
                          <v-tab-item :value="getTabKeyWa" style="width:100%" class="pl-0 py-5" :style="bdyColor" disabled>

                            <vue-tel-input
                              v-model="optinNum"
                              dark
                              style="width:103.5%;"
                              placeholder=""
                              :showDialCode="true"
                              mode="international"
                              disabled
                            >
                            </vue-tel-input>
                          </v-tab-item>

                          <v-tab-item :value="getTabKeyFb" :style="bdyColor">
                            <v-row
                              style="width:100%;height:auto"
                              align="center"
                              class="pl-1"
                              :style="bdyColor"
                            >
                              <v-checkbox
                                input-value="true"
                                disabled
                                style="transform: scale(0.8)"
                                class="pr-0 mr-0"
                              >
                              </v-checkbox>
                              <span class="pr-0" style="font-size:80%">
                            {{ $t("widgets.chckBxTxt1") }}
                          </span>
                              <v-icon color="#0084FF" style="transform: scale(0.8)">
                                mdi-facebook-messenger
                              </v-icon>
                              <span class="pl-0" style="font-size:80%">
                            {{ $t("widgets.chckBxTxt2") }}
                          </span>
                              <span> </span>
                            </v-row>

                            <v-row style="width:100%;height:30%" align="start">
                              <v-container
                                style="height: 15px; width: 15px; border-radius:100%; background-color: #E6E7E8; transform: scale(0.8)"
                                class="mx-2"
                              ></v-container>

                              <span
                                style="font-size: 70%; height:100%; color: #B3B7BA"
                                class="pt-1 mr-2"
                              >{{ $t("widgets.fbUserName") }}</span
                              >

                              <a
                                style="font-size: 70%; height:100%; color: #B3B7BA; text-decoration:underline"
                                class="pt-1"
                              >{{ $t("widgets.wrngUsrTxt") }}</a
                              >
                            </v-row>
                            <v-row style="height:40%; width:100%"> </v-row>
                          </v-tab-item>

                        </v-tabs-items>
                      </v-col>
                    </v-col>
                  </v-col>
                </v-col>
                <v-row style="width:100%" class="pl-6  " align="start" disabled>
                  <v-btn
                    :style="buttonProps"
                    outlined
                    :key="widgetKey"
                    @click="submitClickDisc"
                    style="width: 96%"
                    disabled
                  >
                      <span :style="btnTextProps">
                        {{ buttonText }}
                      </span>
                  </v-btn>
                </v-row>
              </v-col>

            </v-row>
          </v-col>
          <!--          /*FB AND SMS NO DISCOUNT */-->
          <v-row
            style="width:102.5%"
            align="start"
            justify="center"
            v-if="!wdgtTabWhatsappOnly && wdgtTabcheck && !wdgtIsDsc"
            class="pl-2"
            :key="'key1' + wdgtTabKey"
          >
            <v-tabs-items v-model="tab" style="width:90%">
              <v-tab-item :value="getTabKeySMS" style="width:100%" :style="bdyColor">
                <v-row style="width:100%;height:2.5vh" :style="bdyColor">

                </v-row>
                <v-row justify="center" style="width:100%" :style="bdyColor"
                       @click="toggleDialog()" :class="$vuetify.breakpoint.width > 1600 ? 'ml-0' : 'ml-2'">
                  <vue-tel-input
                    v-model="optinNum"
                    dark
                    style="width:80%;"
                    placeholder=""
                    :showDialCode="true"
                    mode="international"
                    disabled
                  >
                  </vue-tel-input>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="getTabKeyFb">
                <v-row
                  style="width:100%;height:60%"
                  align="center"
                  class="pl-1"
                  justify="center"
                  @click="toggleDialog()"
                >
                  <v-checkbox input-value="true" disabled> </v-checkbox>
                  <span class="pr-1">
                    {{ $t("widgets.chckBxTxt1") }}
                  </span>
                  <v-icon color="#0084FF">
                    mdi-facebook-messenger
                  </v-icon>
                  <span class="pl-2">
                    {{ $t("widgets.chckBxTxt2") }}
                  </span>
                </v-row>

                <v-row
                  style="width:100%;height:40%"
                  align="center"
                  justify="center"
                  @click="toggleDialog()"
                >
                  <v-container
                    style="height: 26px; width: 26px; border-radius:100%; background-color: #E6E7E8"
                    class="mx-2"
                  ></v-container>

                  <span
                    style="font-size: 14px; height:100%; color: #B3B7BA"
                    class="pt-1 mr-2"
                  >{{ $t("widgets.fbUserName") }}</span
                  >

                  <a
                    style="font-size: 13px; height:100%; color: #B3B7BA; text-decoration:underline"
                    class="pt-1"
                  >{{ $t("widgets.wrngUsrTxt") }}</a
                  >
                </v-row>
              </v-tab-item>

            </v-tabs-items>
          </v-row>
          <!--          /*Whatsapp and FB AND SMS NO DISCOUNT */-->
          <v-row
            style="width:102.5%"
            align="start"
            justify="center"
            v-if="wdgtTabWhatsappOnly && wdgtTabcheck && !wdgtIsDsc"
            class="pl-2"
            :key="'key1' + wdgtTabKey"
          >
            <v-tabs-items v-model="tab" style="width:90%">
              <v-tab-item :value="getTabKeySMS" style="width:100%" :style="bdyColor">
                <v-row style="width:100%;height:2.5vh" :style="bdyColor">

                </v-row>
                <v-row justify="center" style="width:100%" :style="bdyColor"
                       @click="toggleDialog()" :class="$vuetify.breakpoint.width > 1600 ? 'ml-0' : 'ml-2'">
                  <vue-tel-input
                    v-model="optinNum"
                    dark
                    style="width:80%;"
                    placeholder=""
                    :showDialCode="true"
                    mode="international"
                    disabled
                  >
                  </vue-tel-input>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="getTabKeyFb">
                <v-row
                  style="width:100%;height:60%"
                  align="center"
                  class="pl-1"
                  justify="center"
                  @click="toggleDialog()"
                >
                  <v-checkbox input-value="true" disabled> </v-checkbox>
                  <span class="pr-1">
                    {{ $t("widgets.chckBxTxt1") }}
                  </span>
                  <v-icon color="#0084FF">
                    mdi-facebook-messenger
                  </v-icon>
                  <span class="pl-2">
                    {{ $t("widgets.chckBxTxt2") }}
                  </span>
                </v-row>

                <v-row
                  style="width:100%;height:40%"
                  align="center"
                  justify="center"
                  @click="toggleDialog()"
                >
                  <v-container
                    style="height: 26px; width: 26px; border-radius:100%; background-color: #E6E7E8"
                    class="mx-2"
                  ></v-container>

                  <span
                    style="font-size: 14px; height:100%; color: #B3B7BA"
                    class="pt-1 mr-2"
                  >{{ $t("widgets.fbUserName") }}</span
                  >

                  <a
                    style="font-size: 13px; height:100%; color: #B3B7BA; text-decoration:underline"
                    class="pt-1"
                  >{{ $t("widgets.wrngUsrTxt") }}</a
                  >
                </v-row>
              </v-tab-item>
              <v-tab-item :value="getTabKeyWa">
                <v-row style="width:100%;height:2.5vh" :style="bdyColor">
                </v-row>
                <v-row justify="center" style="width:100%" :style="bdyColor"
                       @click="toggleDialog()" :class="$vuetify.breakpoint.width > 1600 ? 'ml-0' : 'ml-2'">
                  <vue-tel-input
                    v-model="optinNum"
                    dark
                    style="width:80%;"
                    placeholder=""
                    :showDialCode="true"
                    mode="international"
                    disabled
                  >
                  </vue-tel-input>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-row>

          <!--          /*FB AND SMS DISCOUNT */-->
          <v-col cols="11" class="ml-3 no_pad_min_width"   v-if="!wdgtTabWhatsappOnly && wdgtTabcheck && wdgtIsDsc" @click="toggleDialog()">
            <v-row
              style="border:1px solid #C9CACB;"
              align="center"
              justify="center"
              :key="'key2' + wdgtTabKey"
              class="mt-4"
            >
              <v-col cols="3" class="img_vh ma-0 pa-0" style="height:100%;width:100%">
                <v-img
                  src="https://storage.googleapis.com/dev-facebook-cart-recovery.appspot.com/widget/img/discount-icon.png"
                  class="ma-0 pa-0"
                  width="100%"
                  height="35vh"
                  style="background:#4E5D6B"
                >
                </v-img>
              </v-col>
              <v-col cols="9" class="d-flex align-content-space-around  flex-wrap py-0 pl-12" style="height: 35vh !important;" v-if="checkOptin">
                <v-col style="width:100%" class="py-0 pr-2" v-if="dscntCd">
                    <span style="font-weight:bold;font-size:120%; color:#5686F6;width: 100%" :style="msgProps">
                      {{ dscntCd }}
                    </span>
                </v-col>
                <v-row style="width:100%" class="py-0 pr-2" >
                    <span style="width: 100%">
                      {{ dscntInstr }}
                    </span>
                </v-row>

                <v-row style="width:100%" class=" pr-2" >
                  <v-btn :style="buttonProps" outlined @click="resetOptin">
                    <span :style="btnTextProps" style="width: 100%">
                      {{cpDiscCode}}
                    </span>
                  </v-btn>
                </v-row>
              </v-col>

              <v-col cols="9" class="d-flex align-content-space-around  flex-wrap" v-if="!checkOptin" style="height: 35vh !important;">
                <v-col style="width:100%" class="py-0 pr-2">
                      <span style="font-weight:bold; font-size:90%" :style="msgProps">
                        {{ dscntStmt }}
                      </span>
                  <v-col style="width:100%" class="py-0 pl-0 pt-8" disabled>
                    <v-col style="width:100%; " align="center" class="px-0 py-0" :style="bdyColor">
                      <v-col cols="12" class="px-0 py-0" :style="bdyColor">
                        <v-tabs-items v-model="tab" style="width:100%">
                          <v-tab-item :value="getTabKeySMS" style="width:100%" class="pl-0 py-5" :style="bdyColor" disabled>

                            <vue-tel-input
                              v-model="optinNum"
                              dark
                              style="width:103.5%;"
                              placeholder=""
                              :showDialCode="true"
                              mode="international"
                              disabled
                            >
                            </vue-tel-input>
                          </v-tab-item>

                          <v-tab-item :value="getTabKeyFb" :style="bdyColor">
                            <v-row
                              style="width:100%;height:auto"
                              align="center"
                              class="pl-1"
                              :style="bdyColor"
                            >
                              <v-checkbox
                                input-value="true"
                                disabled
                                style="transform: scale(0.8)"
                                class="pr-0 mr-0"
                              >
                              </v-checkbox>
                              <span class="pr-0" style="font-size:80%">
                            {{ $t("widgets.chckBxTxt1") }}
                          </span>
                              <v-icon color="#0084FF" style="transform: scale(0.8)">
                                mdi-facebook-messenger
                              </v-icon>
                              <span class="pl-0" style="font-size:80%">
                            {{ $t("widgets.chckBxTxt2") }}
                          </span>
                              <span> </span>
                            </v-row>

                            <v-row style="width:100%;height:30%" align="start">
                              <v-container
                                style="height: 15px; width: 15px; border-radius:100%; background-color: #E6E7E8; transform: scale(0.8)"
                                class="mx-2"
                              ></v-container>

                              <span
                                style="font-size: 70%; height:100%; color: #B3B7BA"
                                class="pt-1 mr-2"
                              >{{ $t("widgets.fbUserName") }}</span
                              >

                              <a
                                style="font-size: 70%; height:100%; color: #B3B7BA; text-decoration:underline"
                                class="pt-1"
                              >{{ $t("widgets.wrngUsrTxt") }}</a
                              >
                            </v-row>
                            <v-row style="height:40%; width:100%"> </v-row>
                          </v-tab-item>

                        </v-tabs-items>
                      </v-col>
                    </v-col>
                  </v-col>
                </v-col>
                <v-row style="width:100%" class="pl-6  " align="start" disabled>
                  <v-btn
                    :style="buttonProps"
                    outlined
                    :key="widgetKey"
                    @click="submitClickDisc"
                    style="width: 96%"
                    disabled
                  >
                      <span :style="btnTextProps">
                        {{ buttonText }}
                      </span>
                  </v-btn>
                </v-row>
              </v-col>

            </v-row>
          </v-col>
          <!--          /*Whatsapp AND FB AND SMS DISCOUNT */-->
          <v-col cols="11" class="ml-3 no_pad_min_width"   v-if="wdgtTabWhatsappOnly && wdgtTabcheck && wdgtIsDsc" @click="toggleDialog()">
            <v-row
              style="border:1px solid #C9CACB;"
              align="center"
              justify="center"
              :key="'key2' + wdgtTabKey"
              class="mt-4"
            >
              <v-col cols="3" class="img_vh ma-0 pa-0" style="height:100%;width:100%">
                <v-img
                  src="https://storage.googleapis.com/dev-facebook-cart-recovery.appspot.com/widget/img/discount-icon.png"
                  class="ma-0 pa-0"
                  width="100%"
                  height="35vh"
                  style="background:#4E5D6B"
                >
                </v-img>
              </v-col>
              <v-col cols="9" class="d-flex align-content-space-around  flex-wrap py-0 pl-12" style="height: 35vh !important;" v-if="checkOptin">
                <v-col style="width:100%" class="py-0 pr-2" v-if="dscntCd">
                    <span style="font-weight:bold;font-size:120%; color:#5686F6;width: 100%" :style="msgProps">
                      {{ dscntCd }}
                    </span>
                </v-col>
                <v-row style="width:100%" class="py-0 pr-2" >
                    <span style="width: 100%">
                      {{ dscntInstr }}
                    </span>
                </v-row>

                <v-row style="width:100%" class=" pr-2" >
                  <v-btn :style="buttonProps" outlined @click="resetOptin">
                    <span :style="btnTextProps" style="width: 100%">
                      {{cpDiscCode}}
                    </span>
                  </v-btn>
                </v-row>
              </v-col>

              <v-col cols="9" class="d-flex align-content-space-around  flex-wrap" v-if="!checkOptin" style="height: 35vh !important;">
                <v-col style="width:100%" class="py-0 pr-2">
                      <span style="font-weight:bold; font-size:90%" :style="msgProps">
                        {{ dscntStmt }}
                      </span>
                  <v-col style="width:100%" class="py-0 pl-0 pt-8" disabled>
                    <v-col style="width:100%; " align="center" class="px-0 py-0" :style="bdyColor">
                      <v-col cols="12" class="px-0 py-0" :style="bdyColor">
                        <v-tabs-items v-model="tab" style="width:100%">
                          <v-tab-item :value="getTabKeySMS" style="width:100%" class="pl-0 py-5" :style="bdyColor" disabled >
                            <vue-tel-input
                              v-model="optinNum"
                              dark
                              style="width:103.5%;"
                              placeholder=""
                              :showDialCode="true"
                              mode="international"
                              disabled
                            >
                            </vue-tel-input>
                          </v-tab-item>
                          <v-tab-item :value="getTabKeyFb" :style="bdyColor" >
                            <v-row
                              style="width:100%;height:auto"
                              align="center"
                              class="pl-1"
                              :style="bdyColor"
                            >
                              <v-checkbox
                                input-value="true"
                                disabled
                                style="transform: scale(0.8)"
                                class="pr-0 mr-0"
                              >
                              </v-checkbox>
                              <span class="pr-0" style="font-size:80%">
                            {{ $t("widgets.chckBxTxt1") }}
                          </span>
                              <v-icon color="#0084FF" style="transform: scale(0.8)">
                                mdi-facebook-messenger
                              </v-icon>
                              <span class="pl-0" style="font-size:80%">
                            {{ $t("widgets.chckBxTxt2") }}
                          </span>
                              <span> </span>
                            </v-row>

                            <v-row style="width:100%;height:30%" align="start">
                              <v-container
                                style="height: 15px; width: 15px; border-radius:100%; background-color: #E6E7E8; transform: scale(0.8)"
                                class="mx-2"
                              ></v-container>

                              <span
                                style="font-size: 70%; height:100%; color: #B3B7BA"
                                class="pt-1 mr-2"
                              >{{ $t("widgets.fbUserName") }}</span
                              >

                              <a
                                style="font-size: 70%; height:100%; color: #B3B7BA; text-decoration:underline"
                                class="pt-1"
                              >{{ $t("widgets.wrngUsrTxt") }}</a
                              >
                            </v-row>
                            <v-row style="height:40%; width:100%"> </v-row>
                          </v-tab-item>
                          <v-tab-item :value="getTabKeyWa" >
                              <vue-tel-input
                            v-model="optinNum"
                            dark
                            style="width:103.5%;"
                            placeholder=""
                            :showDialCode="true"
                            mode="international"
                            disabled
                          >
                          </vue-tel-input>
                          </v-tab-item>
                        </v-tabs-items>
                      </v-col>
                    </v-col>
                  </v-col>
                </v-col>
                <v-row style="width:100%" class="pl-6  " align="start" disabled>
                  <v-btn
                    :style="buttonProps"
                    outlined
                    :key="widgetKey"
                    @click="submitClickDisc"
                    style="width: 96%"
                    disabled
                  >
                      <span :style="btnTextProps">
                        {{ buttonText }}
                      </span>
                  </v-btn>
                </v-row>
              </v-col>

            </v-row>
          </v-col>


          <v-row
            style="width:102.5%"
            align="center"
            justify="center"
            v-if="wdgtTabcheck && !wdgtIsDsc"
            :key="'key3' + wdgtTabKey"
            @click="submitClickDisc()"
            class="mt-8"
          >
            <v-btn :style="buttonProps" outlined :key="widgetKey" style="width: 249px !important;height: 50px !important;">
              <span :style="btnTextProps">
                {{ buttonText }}
              </span>
            </v-btn>
          </v-row>

          <v-row
            class="mt-4 mb-4"
            style="width:102.5%"
            align="center"
            justify="center"
            @click="toggleDialog()"
          >
            <a :style="cancelProps">{{ cancelText }}</a>
          </v-row>
        </v-container>
      </v-card>
    </v-row>

    <!--    /* SHOW DISC OR SUBMIT SCREEN */-->

    <v-row justify="center"  class="button_bottom_spaces"  v-if="didOptIn == true && subsTy == 'subscribe'">
      <v-btn
        tile
        depressed
        color="#4e5d6b"
        style="border-width:1px;color: white;width:284px; "
        @click="didOptIn = false;"
      >
        {{ $t("widgets.ShowSubmitButton") }}
      </v-btn>
    </v-row>

    <v-row justify="center" class="button_bottom_spaces"  v-if="didOptIn == false && subsTy == 'subscribe'">
      <v-btn
        tile
        depressed
        color="#4e5d6b"
        style="border-width:1px;color: white;width: 284px"
        @click="didOptIn = true;"
      >
        {{ $t("widgets.ShowDiscountButton") }}
      </v-btn>
    </v-row>

    <!--    <v-row justify="center" :class="subsTy !== 'subscribe' ? 'mt-5' : ''" >-->
    <!--      <v-btn-->
    <!--        tile-->
    <!--        outlined-->
    <!--        class="#4E5D6B&#45;&#45;text"-->
    <!--        color="#4E5D6B"-->
    <!--        style="border-width:1px"-->
    <!--        :disabled="detectChange"-->
    <!--        @click="resetChanges"-->
    <!--      >-->
    <!--        {{ $t("widgets.resetButton") }}-->
    <!--      </v-btn>-->
    <!--    </v-row>-->
  </v-container>
</template>

<script>
/* eslint-disable vue/return-in-computed-property */
import { mapGetters } from "vuex";
import SmsIcon from "@/assets/icons/sms-icon.svg";
import FbIcon from "@/assets/icons/facebook-icon.svg";
import WaIcon from "@/assets/icons/wa-icon.svg";

export default {
  name: "WidgetViewCheckBox",
  components: { SmsIcon, FbIcon,WaIcon },
  data() {
    return {
      dialog: false,
      btnId: 0,
      didOptIn: false,
      optinNum: "",
      tab: null,
      wdgtTabKey: 0,
      keyDependPosit:1,
      opacity:'',
    };
  },
  mounted(){
    this.activeIcon(this.getTabHeader1)
  },
  methods: {
    incrBtnId() {
      this.btnId++;
    },
    toggleDialog() {
      // console.log("Inside toggle dialog :: " + this.dialog);
      this.dialog = !this.dialog;
    },
    ovrlyClose() {
      this.dialog = !this.dialog;
    },
    resetChanges() {
      this.$store.dispatch("getWidgets");
    },
    submitClickDisc() {
      this.didOptIn = true;
    },
    resetOptin() {
      this.didOptIn = false;
    },
    activeIcon(item){
      this.opacity = item
    }
  },
  computed: {
    ...mapGetters(["getWidgetsState","getWidgEU"]),
    detectEuRegion(){
      return this.getWidgEU
    },
    getBgWidgCheckBody(){
      return this.$store.getters.getBgWidgCheckBody
    },
    subsTy(){
      return this.$store.getters.getWdgSubType
    },
    detectChange() {
      return this.getWidgetsState.changesSaved;
    },
    bcgColor() {
      let hdrClsObj = {
        "background-color": this.getWidgetsState.header_background_color,
      };
      return hdrClsObj;
    },
    bdyColor() {
      let bdyClsObj = {
        "background-color": this.getWidgetsState.popup_background_color,
      };
      return bdyClsObj;
    },
    titleText() {
      return this.getWidgetsState.pop_up_title;
    },
    titleProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_title_font_color,
        "font-weight": this.getWidgetsState.pop_up_title_font_type,
        "font-size": this.getWidgetsState.pop_up_title_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_title_font_family,
      };
      return ttlObj;
    },
    msgText() {
      return this.getWidgetsState.pop_up_message;
    },
    msgProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_message_font_color,
        "font-weight": this.getWidgetsState.pop_up_message_font_type,
        "font-size": this.getWidgetsState.pop_up_message_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_message_font_family,
        "text-align": "center",
      };
      return ttlObj;
    },
    cancelText() {
      return this.getWidgetsState.pop_up_cancel;
    },
    cancelProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_cancel_font_color,
        "font-weight": this.getWidgetsState.pop_up_cancel_font_type,
        "font-size": this.getWidgetsState.pop_up_cancel_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_cancel_font_family,
        "text-decoration": "underline",
        "text-align": "center",
      };
      return ttlObj;
    },
    buttonText() {
      this.incrBtnId();
      // console.log("button Text" + this.getWidgetsState.button_text);
      return this.getWidgetsState.button_text;
    },
    buttonProps() {
      let borderRad =
        this.getWidgetsState.button_corners == "Round" ? "8px" : "0px";
      let buttonObj = {
        "background-color": this.getWidgetsState.button_background,
        "border-color": this.getWidgetsState.button_border_color,
        "border-radius": borderRad,
        "border-width": this.getWidgetsState.button_border_size + "px",
      };
      return buttonObj;
    },
    btnTextProps() {
      let btnObj = {
        color: this.getWidgetsState.button_font_color,
        "font-family": this.getWidgetsState.button_font_family,
        "font-weight": this.getWidgetsState.button_font_type,
        "font-size": this.getWidgetsState.button_font_size + "px",
        "text-transform": "none",
      };
      return btnObj;
    },
    widgetType() {
      return this.getWidgetsState.facebook_widget_type;
    },
    widgetKey() {
      return "key" + this.getWidgetsState.wdgt_key_internal + "b" + this.btnId;
    },
    wdgtFBcheck() {
      return (
        this.getWidgetsState.enabled_widgets.facebook.enabled &&
        !this.getWidgetsState.enabled_widgets.sms.enabled
      );
    },
    wdgtSMScheck() {
      return (
        !this.getWidgetsState.enabled_widgets.facebook.enabled &&
        this.getWidgetsState.enabled_widgets.sms.enabled
      );
    },
    wdgtTabcheck() {
      return (
        this.getWidgetsState.enabled_widgets.facebook.enabled &&
        this.getWidgetsState.enabled_widgets.sms.enabled
      );
    },
    wdgtTabWhatsapp(){
      return(
        !this.getWidgetsState.enabled_widgets.facebook.enabled &&
        !this.getWidgetsState.enabled_widgets.sms.enabled &&
        this.getWidgetsState.enabled_widgets.whatsapp.enabled
      )
    },
    wdgtTabWhatsappOnly(){
      return(
        this.getWidgetsState.enabled_widgets.whatsapp.enabled
      )
    },
    wdgtTabHaveTwo() {
      return (
        (this.getWidgetsState.enabled_widgets.facebook.enabled &&
        this.getWidgetsState.enabled_widgets.sms.enabled) ||
        (this.getWidgetsState.enabled_widgets.facebook.enabled &&
          this.getWidgetsState.enabled_widgets.whatsapp.enabled) ||
        (this.getWidgetsState.enabled_widgets.sms.enabled &&
          this.getWidgetsState.enabled_widgets.whatsapp.enabled)
      );
    },
    getTwoRight(){
       if(
        (this.getWidgetsState.enabled_widgets.sms.enabled && this.getWidgetsState.enabled_widgets.whatsapp.enabled) ||
        (this.getWidgetsState.enabled_widgets.sms.enabled && this.getWidgetsState.enabled_widgets.facebook.enabled) ||
        (this.getWidgetsState.enabled_widgets.whatsapp.enabled && this.getWidgetsState.enabled_widgets.facebook.enabled)
      ){
        return true
      }
    },
    getTabHeader1() {
      if (this.getWidgetsState.enabled_widgets.facebook.position == 1 && this.getWidgetsState.enabled_widgets.facebook.enabled) {
        return "FbIcon";
      }else if(this.getWidgetsState.enabled_widgets.whatsapp.position == 1 && this.getWidgetsState.enabled_widgets.whatsapp.enabled){
        return "WaIcon";
      }else if(this.getWidgetsState.enabled_widgets.sms.position == 1 && this.getWidgetsState.enabled_widgets.sms.enabled){
        return "SmsIcon";
      }
    },
    getTabHeader2() {
      if (this.getWidgetsState.enabled_widgets.facebook.position == 2 && this.getWidgetsState.enabled_widgets.facebook.enabled) {
        return "FbIcon";
      }else if(this.getWidgetsState.enabled_widgets.whatsapp.position == 2 && this.getWidgetsState.enabled_widgets.whatsapp.enabled){
        return "WaIcon";
      }else if(this.getWidgetsState.enabled_widgets.sms.position == 2 && this.getWidgetsState.enabled_widgets.sms.enabled){
        return "SmsIcon";
      }
    },
    getTabHeader3() {
      if (this.getWidgetsState.enabled_widgets.facebook.position == 3 && this.getWidgetsState.enabled_widgets.facebook.enabled) {
        return "FbIcon";
      }else if(this.getWidgetsState.enabled_widgets.whatsapp.position == 3 && this.getWidgetsState.enabled_widgets.whatsapp.enabled){
        return "WaIcon";
      }else if(this.getWidgetsState.enabled_widgets.sms.position == 3 && this.getWidgetsState.enabled_widgets.sms.enabled){
        return "SmsIcon";
      }
    },
    getTabKeySMS() {
      return this.getWidgetsState.enabled_widgets.sms.position
        - this.keyDependPosit;
    },

    getTabKeyFb() {
      return this.getWidgetsState.enabled_widgets.facebook.position
        - this.keyDependPosit;
    },
    getTabKeyWa(){
      return this.getWidgetsState.enabled_widgets.whatsapp.position
        - this.keyDependPosit;
    },
    wdgtIsDsc() {
      return this.getWidgetsState.subscribe_type != "default";
    },
    dscntStmt() {
      return this.getWidgetsState.discount_statement;
    },
    checkOptin() {
      return this.didOptIn;
    },
    dscntCd() {
      return this.getWidgetsState.discount_code;
    },
    dscntInstr() {
      return this.getWidgetsState.apply_discount_instruction;
    },
    cpDiscCode(){
      return this.$store.getters.getCopyDiscountCodeButton
    }
  },
  watch: {
    getTabHeader1(newValue) {
      console.log("new value of header 1 ::" + newValue);
    },
    getTabHeader2(newValue) {
      console.log("new value of header 1 ::" + newValue);
    },
    getTabHeader3(newValue) {
      console.log("new value of header 1 ::" + newValue);
    },
  },

  beforeCreate() {
    this.$store.dispatch("updIsLoading", true).then(() => {
      this.$store.dispatch("getWidgets").then(() => {
        this.$store.dispatch("updIsLoading", false);
      });
    });
  },
};
</script>

<style scoped>
.opacPresent{
  opacity: 0.5 ;
}
.wdg_view_Check_box .ovr_pd{
  padding: 8px 15px !important;
}
.fb-btn {
  border-radius: 7px;
  text-transform: none;
}
.title_offer{
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}
.text_offer{
  padding-bottom: 28px !important;
}
.button_bottom_spaces{
  margin-top: 26px;
  margin-bottom: 26px;
}
@media (max-width: 1450px) {
  .title_offer{
    padding-top: 28px !important;
    padding-bottom: 8px !important;
  }
  .text_offer{
    padding-bottom: 0px !important;
    margin-bottom: 10px ;
  }
  .no_pad_min_width{
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .button_bottom_spaces{
    margin-top: 19px;
    margin-bottom: 19px;
  }
}
</style>

<style >
.img_vh  .v-responsive__content{
  height: 23vh !Important;
  /*height: calc(100% - 100px);*/
}



.img_vh_med v-responsive__content{
  height: 24vh !Important;
}
.img_vh_big v-responsive__content{
  height: 26vh !Important;
}

</style>